import { useLocale } from '@adsk/alloy-react-locale';
export function useUnspecifiedProps() {
    var T = useLocale(function (_a) {
        var locale = _a.locale;
        return require("../LocationPicker/i18n/".concat(locale, ".json"));
    }).T;
    var UNSPECIFIED = T.translate('cardHeader.unspecified');
    var unspecifiedId = '___unspecified___';
    var unspecifiedItem = {
        id: unspecifiedId,
        name: UNSPECIFIED,
        children: [],
        type: '',
        order: 0,
    };
    var menuItem = {
        id: unspecifiedId,
        label: UNSPECIFIED,
        show: false,
        path: [],
        childIds: [],
        original: unspecifiedItem,
    };
    return {
        unspecifiedId: unspecifiedId,
        UNSPECIFIED: UNSPECIFIED,
        unspecifiedItem: unspecifiedItem,
        menuItem: menuItem,
    };
}
